import {
    IFetchLoggedInUserAction,
    IHasLoginErrorsAction,
    ILoginAction,
    ISetLoggedInUserAction,
    ISetLoginErrorMessageAction,
    ISetUserValidationErrorsAction,
    IUpdateUserAction,
} from './types/auth.types';
import {User, UserConfig} from '../../incase-domain/user';
import {TypedTranslation} from '../../i18n';

export const LOGIN_ACTION = 'LOGIN_ACTION';
export const HAS_ERROR_ACTION = 'HAS_ERROR_ACTION';
export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const FETCH_LOGGED_IN_USER_ACTION = 'FETCH_LOGGED_IN_USER_ACTION';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_USER_VALIDATION_ERRORS = 'SET_USER_VALIDATION_ERRORS';
export const SET_LOGIN_ERROR_MESSAGE = 'SET_LOGIN_ERROR_MESSAGE';

export const loginAction = (username: string, password: string): ILoginAction => ({
    type: LOGIN_ACTION,
    credentials: {
        username,
        password,
    },
});

export const fetchLoggedInUserAction = (setHasAttemptedFetch?: () => void): IFetchLoggedInUserAction => ({
    type: FETCH_LOGGED_IN_USER_ACTION,
    setHasAttemptedFetch,
});

export const hasLoginErrorAction = (hasError: boolean): IHasLoginErrorsAction => ({
    type: HAS_ERROR_ACTION,
    payload: hasError,
});

export const setLoginErrorMessageAction = (errorMessage: TypedTranslation | null): ISetLoginErrorMessageAction => ({
    type: SET_LOGIN_ERROR_MESSAGE,
    payload: errorMessage,
});

export const setLoggedInUserAction = (user?: User): ISetLoggedInUserAction => ({
    type: SET_LOGGED_IN_USER,
    user,
});

export const updateUserAction = (user: User, userConfig: UserConfig): IUpdateUserAction => ({
    type: UPDATE_USER,
    payload: {user, userConfig},
});

export const setUserValidationErrorsAction = (errors: Record<string, string[]>): ISetUserValidationErrorsAction => ({
    type: SET_USER_VALIDATION_ERRORS,
    errors,
});
